<svelte:options customElement={{
  tag: 'select-field',
  shadow: 'none',
  props: {
    name: { reflect: true, type: 'String' },
    options: { reflect: true, type: 'String' },
    placeholder: { reflect: true, type: 'String' },
    value: { reflect: true, type: 'String' },
    error: { reflect: true, type: 'String' }
  }
}} />

<script>
  import SvgIcon from '../SvgIcon.svelte';

  /**
   * select：プルダウン
   * パーツライブラリ準拠の mod-select 構造
   */
  export let name = '';
  export let options = '[]';
  export let placeholder = '選択してください';
  export let value = '';
  export let error = '';

  let parsedOptions = [];
  let selectId = `select_${name || Math.random().toString(36).slice(2, 8)}`;

  $: {
    try {
      parsedOptions = typeof options === 'string' ? JSON.parse(options) : (Array.isArray(options) ? options : []);
    } catch (e) {
      parsedOptions = [];
    }
  }
</script>

<div class:__error={!!error}>
  <label class="mod-select" for={selectId}>
    <select id={selectId} {name} bind:value on:change>
      <option value="">{placeholder}</option>
      {#each parsedOptions as option}
        <option value={option.value || option}>{option.label || option}</option>
      {/each}
    </select>
    <SvgIcon name="arrow_bottom" size="sm" />
  </label>
  {#if error}
    <p class="color_red mt10">{error}</p>
  {/if}
</div>
